import Vue from 'vue';
import router from '@/router/index';

import {
  StateMachine,
  State,
  PseudoState,
  Region,
  PseudoStateKind,
  JSONInstance,
  TransitionKind,
  setLogger,
  Transition
} from "@steelbreeze/state";

import machineStateIndex from './machineState/index';
import {ResumeFsm,SaveFsm,RequestSaveFsm} from './messages';
import {saveState} from '@/api/sessionApi';
import store from '@/store/index';

export const logLevelMachineLog   = (1 << 1);
export const logLevelMachineWarn  = (1 << 2);
export const logLevelMachineError = (1 << 3);
export const logLevelMachineAll   = (1 << 1)|(1 << 2)|(1 << 3);
export const logLevelMessageMatch = (1 << 4);
export const logLevelMessageOther = (1 << 5);
export const logLevelMessage      = (1 << 6);
export const logLevelApi          = (1 << 7);
export const logLevelAll          = ((1<<8)-1);
export const logLevelDebug = logLevelApi | logLevelMessage | logLevelMachineAll;

let messageQueue = [];
let table = {};
let tree = {};

let log = ({context,level},item) => {
  if(context.state.verbosity & level) {
  // console.log(context, item);
  }
};

let setState = (newState, parent, name) => ((parent||tree)[name] = table[newState.toString()] = newState);
let addState = (name,parent,kind) => kind 
  ? setState(new PseudoState(name,parent,kind),parent,name)
  : parent
    ? setState(new State(name,parent,kind),parent,name)
    : setState(new StateMachine(name),parent,name);
let addRegion = (name,parent) =>  setState(new Region(name,parent),parent,name);
let isNotMessage = () => false;
let messageIs = (...args) => args.length
  ? (instance,message) => { 
    let context = instance.context;
    let x = {
      context,
      level : logLevelMessageOther
    };
    log(x,'messageIs');
    log(x,message);
    if(message.message &&args.some(arg=>{
      log(x,arg);
      let isMatch = message.message === arg;
      log(x,`isMatch=${isMatch}`);
      return isMatch;
    }))
    {
      log({
        context,
        level:logLevelMessageMatch
      },'messageIs '+ message.message);
      return true;
    }
    else
    {
      log(x,'nomatch');
      return false;
    }
  }
  : isNotMessage;
let messageIsNot = (...args) => {
  if(args.length === 0)
    return ()=>true;
  else
    return (instance,message) => !(messageIs(...args)(instance,message));
};

let nextRouterHook = ({}={},{next})=>next(true);

let navigate = (name,params) => {
  return (instance) => {
    let destination = { name };
    if(params !== undefined)
      destination.params = _.mapValues(params,o=>o(instance));
    router.push(destination).catch(err => {});
  };
};

let api = { 
  addState,
  addRegion, 
  PseudoStateKind,
  messageIs,
  messageIsNot,
  TransitionKind,
  nextRouterHook,
  navigate
};

let setupLogs = (context) => {
  if(true || tree.machineState)
  {
    setLogger({
      log : item  => {},//log({context,level:logLevelMachineLog},item),
      warn : item  => {},//log({context,level:logLevelMachineWarn},item),
      error : item  => {}//log({context,level:logLevelMachineError},item),
    })
  }
};
let setupInstance = (instance, context, params={}) => {
  instance.context = context;
  instance.params = params;
  instance.log = (item) => log({context,level:logLevelApi},item);
};

let tearDownInstance = instance => {
  instance.log = null;
  instance.context = null;
};

let isInitialized = () => Object.keys(table).length > 0;
let initialize = (context) => {
  context.commit({type:'logLevel',level:logLevelDebug});
  Transition.internalTransitionsTriggerCompletion = true;
  let parent = tree;
  machineStateIndex({api,parent,tree:false});
  machineStateIndex({api,parent,tree});
  let instance = new JSONInstance("MachineInstance");
  instance.context = context;
  Transition.internalTransitionsTriggerCompletion = true;
  tree.machineState.initialise(instance);
  Transition.internalTransitionsTriggerCompletion = true;
  return instance;
};

let processMessages = ({context,instance}) => {
  let alreadySaved = messageQueue.length === 1 && 
    SaveFsm === messageQueue[0].message ||  RequestSaveFsm === messageQueue[0].message;
  while(messageQueue.length > 0)
  {
    let x = {context,level:logLevelMessage};
    let y = {context,level:logLevelMessageOther};
    let message = messageQueue[0];
    log(x,'CURRENT MESSAGE '+message.message);
    let serializedInstance = instance.toJSON();
    log(y,'serialzedInstance:'+serializedInstance);
    if(message.message === ResumeFsm)
    {
      log(y,'restored fsm:'+message.instance);
      instance.root = JSON.parse(message.instance);
      context.commit('changed',message.instance);
    }
    else if(message.message === SaveFsm)
    {
      saveState(serializedInstance);
    }
    log(x,'BEGIN EVAL '+message.message);
    if(!('tostring' in message))
    {
      message.toString = ()=>`(${message.message})`;
    }

    // let params = typeof message !== 'undefined' && typeof message.to !=='undefined'?message.to.params:null;
    setupInstance(instance,context);
    table.machineState.evaluate(instance,message);
    tearDownInstance(instance);
    log(x,'END EVAL '+message.message); 
    serializedInstance = instance.toJSON();
    log(y,'serialzedInstance:'+serializedInstance);
    context.commit('changed',serializedInstance);
    messageQueue.shift();
  }
  if(!alreadySaved) {
    setupInstance(instance, context);
    table.machineState.evaluate(instance,{message:RequestSaveFsm,toString:()=>RequestSaveFsm});
    tearDownInstance(instance);
  }
};

const state = {
  serializedInstance: null,
//  verbosity: logLevelAll
 verbosity: logLevelDebug
};

const mutations = {
  changed(state,newSerializedInstance) {
    state.serializedInstance = newSerializedInstance;
  },
  logLevel(state,payload) {
    state.verbosity = payload.level;
  }
};

const actions = {
  evaluate(context,message) {
    let x = {context,level:logLevelMessageOther};
    setupLogs(context);
    let instance;
    if(isInitialized())
    {
      instance = new JSONInstance("MachineInstance");
      if(context.state.serializedInstance)
      {
        log(x,'parsed instance:'+context.state.serializedInstance);
        instance.root = JSON.parse(context.state.serializedInstance);
      }
    }
    else
    {
      instance = initialize(context);
    }
    messageQueue.push(message);
    if(messageQueue.length === 1)
    {
      processMessages({context,instance});
      let serializedInstance = instance.toJSON();
      context.commit('changed',serializedInstance);
    }
    else
      log(x,`handle later ${message.message}`);
  }
};
export async function post(message) {
  return window.store.dispatch('fsm/evaluate',message,{root:true});
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
